import type { LicenseKind } from "../pages/Inventory";

/**
 * Kinds where character/franchise IP is the actual real-world risk this
 * app's licence tracking exists for (stickers/figures, both drawing from
 * anime and game franchises) -- everything else (a cable, a bundle box, an
 * electronics accessory) has no licensing question to begin with. Isaac,
 * 2026-09-18: "this is a cable electronics category why is it making me
 * select a licence option... does not pertain to 99 percent of our
 * products."
 *
 * Shared by every "new SKU" form (Inventory's Add product / resolve dialog,
 * Marketplaces' Create SKU) so the default can't drift between them again --
 * it already had, once, before this file existed.
 */
export const LICENSE_REVIEW_KINDS = ["sticker_single", "sticker_sheet", "figure"];

export function defaultLicenseKindForKind(kind: string): LicenseKind {
  return LICENSE_REVIEW_KINDS.includes(kind) ? "unreviewed" : "original";
}
